import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import { thousandSeparator, checkAuthorization } from "../utils/utils";
import moment from "moment";
import { responseSelector } from '../utils/helpers/selectors';

const { Select2, Date, DateTime, Text } = Inputs;

function UsuariosList({ history, match }) {
  const dispatch = useDispatch();

  const modelUsuarios = useSelector(
    (state) => state.usuarios
  );

  const [usuarios, setUsuarios] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const { data, error } = responseSelector(modelUsuarios);
  
    if (error) {
      alert(error);
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      setUsuarios(data.items);
      setTotalResults(data.total);

      dispatch(controller.duck.actions.clear());
    }
  }, [modelUsuarios]);

  useEffect(() => {
    dispatch(controller.getUsuariosThunk(1, 10));
  }, []);

  function handlePage(page) {
  
    setActivePage(page);
    setUsuarios([]);
    dispatch(controller.getUsuariosThunk(page + 1, pageSize));
  }

  return (
    <Content
      title="Usuarios"
      subTitle="Usuarios"
      browserTitle="Usuarios"
      show={false}
    >
      <Row>
        <Col md="10" mdOffset="1">
          <Box title="Usuarios">
           
            <div>
              <span>Total: {totalResults}</span>
            </div>
            {usuarios && usuarios.length > 0 ? (
              <SimpleTable
              hover={true}
                data={usuarios.map((row, index) => {
                  return {
                    nombre: row.nombre,
                    email: row.email,
                    telefono: row.phoneNumber,
                    creado: moment(row.tsCreated).format("DD-MM-YYYY"),
                    planes:(<Button
                      type="primary"
                      text="Ver planes"
                      onClick={() =>
                        history.push(`/suscripcionesByUsuario/${row._id}/${match.params.localId}`)
                      }
                    />),

                  };
                })}
                columns={[
                  { title: "Nombre", data: "nombre" },
                  { title: "Correo", data: "email" },
                  { title: "Telefono", data: "telefono" },
                  { title: "Creado", data: "creado" },
                  { title: "Planes", data: "planes" },
                  
                ]}
              />
            ) : (
              <h4>No se han encontrado publicaciones</h4>
            )}
            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels= {{
                first: 'Primera',
                last: 'Última',
                previous: 'Anterior',
                next: 'Siguiente',
              }}              
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default UsuariosList;
